export class HeaderDetails {
    $id: string;
    InvolvedVehicleBrand?: any;
    InvolvedVehicleLicensePlate?: any;
    InvolvedVictimName?: any;
    InvolvedVisitBuildingNumber: string;
    InvolvedVisitBuildingNumberAddition: string;
    InvolvedVisitCity: string;
    InvolvedVisitName: string;
    InvolvedVisitPostalCode: string;
    InvolvedVisitStreetName: string;
    CaseID: string;
    InsuredPersonName: string;
    CaseDate: string;
    DenyAccess: boolean;
    IsArchived: boolean;
    IsCaseMissing: boolean;
    RemarkList?: any;
    DepartmentDivisionID: string;
    DepartmentID: string;

    public constructor(init?: Partial<HeaderDetails>) {
        Object.assign(this, init);
    }
}
